import { Component } from '@angular/core';
import { WtfSplashScreenService } from './services/core/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';

@Component({
    selector   : 'wtf-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{

    constructor(
        private wtfSplashScreen: WtfSplashScreenService,
        private translate: TranslateService
    )
    {
        // Add languages
        this.translate.addLangs(['en', 'es']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
    }
}
